interface IJson {
  [key: string]: IJson | string | IJson[]
}

/* eslint-disable @typescript-eslint/camelcase */
const loaders: { [key: string]: () => Promise<IJson> } = {
  bg: () => import('../resources/bg.translations.json'),
  cz: () => import('../resources/cs.translations.json'),
  de: () => import('../resources/de.translations.json'),
  el: () => import('../resources/el.translations.json'),
  en: () => import('../resources/en.translations.json'),
  'en-US': () => import('../resources/en.translations.json'),
  'en-GB': () => import('../resources/en-rGB.translations.json'),
  es: () => import('../resources/es.translations.json'),
  fil: () => import('../resources/fil.translations.json'),
  fr: () => import('../resources/fr.translations.json'),
  hr: () => import('../resources/hr.translations.json'),
  hu: () => import('../resources/hu.translations.json'),
  in: () => import('../resources/id.translations.json'),
  it: () => import('../resources/it.translations.json'),
  ja: () => import('../resources/ja.translations.json'),
  ko: () => import('../resources/ko.translations.json'),
  ms: () => import('../resources/ms.translations.json'),
  pl: () => import('../resources/pl.translations.json'),
  pl_PL: () => import('../resources/pl.translations.json'),
  'pl-PL': () => import('../resources/pl.translations.json'),
  pt: () => import('../resources/pt.translations.json'),
  pt_BR: () => import('../resources/pt-rBR.translations.json'),
  'pt-BR': () => import('../resources/pt-rBR.translations.json'),
  ro: () => import('../resources/ro.translations.json'),
  ru: () => import('../resources/ru.translations.json'),
  se: () => import('../resources/sv.translations.json'),
  th: () => import('../resources/th.translations.json'),
  tr: () => import('../resources/tr.translations.json'),
  uk: () => import('../resources/uk.translations.json'),
}
/* eslint-enable */

export default function(lng: string): Promise<IJson> {
  const load = loaders[lng]
  if (!load) {
    return undefined
  }

  return load().then(module =>
    module && (module as any).__esModule && (module as any).default
      ? (module as any).default
      : module,
  )
}
